import React from 'react';
import { Body, CloseButton, Container, Header, Title } from './elements';

export interface ModalLayoutComponentProps {
  dataHook?: string;
  title?: string;
  isRTL?: boolean;
  isMobile?: boolean;
  onClose?(): void;
}

export const ModalLayout: React.FC<ModalLayoutComponentProps> = (props) => {
  const {
    dataHook,
    title,
    isRTL,
    children,

    onClose,
  } = props;

  return (
    <Container dataHook={dataHook}>
      {title && (
        <Header isRTL={isRTL}>
          <Title>{title}</Title>
          {onClose && <CloseButton onClick={onClose} />}
        </Header>
      )}
      <Body>{children}</Body>
    </Container>
  );
};
ModalLayout.displayName = 'ModalLayout';
